import { render, staticRenderFns } from "./VChargeTemplateForm.vue?vue&type=template&id=7864504c&"
import script from "./VChargeTemplateForm.vue?vue&type=script&lang=js&"
export * from "./VChargeTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports